import { Box, Grid, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { DEFAULT_DF_CON } from '../form-branch'

const OpModelDF = () => {
    const { t } = useTranslation()
    const optionModelDF = [
        {
            name: t('BRANCH.TAB.SENTTING.DF_TREAMENT_PAY_1'), value: DEFAULT_DF_CON.PAY_1,
            component: <ModelDF showType='0' />,
        },
        {
            name: t('BRANCH.TAB.SENTTING.DF_TREAMENT_PAY_2'), value: DEFAULT_DF_CON.PAY_2,
            component: <ModelDF showType='1' />,
        },
        {
            name: t('BRANCH.TAB.SENTTING.DF_TREAMENT_PAY_3'), value: DEFAULT_DF_CON.PAY_3,
            component: <ModelDF showType='2' />,
        },
        {
            name: t('BRANCH.TAB.SENTTING.DF_TREAMENT_PAY_4'), value: DEFAULT_DF_CON.PAY_4,
            component: <ModelDF showType='3' />,
        },
        {
            name: t('BRANCH.TAB.SENTTING.DF_TREAMENT_PAY_5'), value: DEFAULT_DF_CON.PAY_5,
            component: <ModelDF showType='4' />,
        }
    ]
    return (optionModelDF)
}

export default OpModelDF

interface ModelDFProps {
    showType: '0' | '1' | '2' | '3' | '4'
}
const ModelDF = (props: ModelDFProps) => {
    const { showType } = props
    const { t } = useTranslation()

    return (
        <Box display='flex' flexDirection='column' gap='16px' height='100%'>
            <Box >
                <Typography fontSize={'20px'} fontWeight={'500'} marginBottom='8px'>
                    {t('BRANCH.TAB.SENTTING.CONDITION_REPORT_DF')}
                </Typography>
            </Box>

            <Box>
                <Typography fontSize={'16px'} fontWeight={'500'} marginBottom='8px'>
                    {t(`BRANCH.TAB.SENTTING.TITLE_PAY_${showType}`)}
                </Typography>
                <Typography fontSize={'16px'} fontWeight={'400'} paddingLeft='20px' color='#5A5A5A'>
                    {t(`BRANCH.TAB.SENTTING.TITLE_SUB_PAY_${showType}`)}
                </Typography>
            </Box>

            <Box>
                <Typography fontSize={'16px'} fontWeight={'500'} marginBottom='8px'>
                    {t(`BRANCH.TAB.SENTTING.CALCULATE.CAL_TITLE`)}
                </Typography>
                <Box marginTop="8px" padding="16px" bgcolor={'#ffffff'} fontStyle="italic">
                    <Grid container item>
                        <Grid item sm={6}>
                            <Typography fontSize={'16px'} fontWeight={'400'} paddingLeft='20px' color='#5A5A5A'>
                                {t(`BRANCH.TAB.SENTTING.CALCULATE.PAY_${showType}.TREATMENT_COST_AFTER_CLINIC_FEE`)}
                            </Typography>
                        </Grid >
                        <Grid item sm={6}>
                            <Typography fontSize={'16px'} fontWeight={'400'} paddingLeft='20px' color='#5A5A5A'>
                                {t(`BRANCH.TAB.SENTTING.CALCULATE.PAY_${showType}.CREDIT_CARD_TREATMENT_COST_MINUS_CLINIC_FEE`)}
                            </Typography>
                        </Grid >
                    </Grid>
                    <Grid container item>
                        <Grid item sm={6}>
                            <Typography fontSize={'16px'} fontWeight={'400'} paddingLeft='20px' color='#5A5A5A'>
                                {t(`BRANCH.TAB.SENTTING.CALCULATE.PAY_${showType}.DF_BEFORE_CARD_DEDUCTION`)}
                            </Typography>
                        </Grid >
                        <Grid item sm={6}>
                            <Typography fontSize={'16px'} fontWeight={'400'} paddingLeft='20px' color='#5A5A5A'>
                                {t(`BRANCH.TAB.SENTTING.CALCULATE.PAY_${showType}.DF_CALCULATION`)}
                            </Typography>
                        </Grid >
                    </Grid>
                    <Grid container item>
                        <Grid item sm={6}>
                            <Typography fontSize={'16px'} fontWeight={'400'} paddingLeft='20px' color='#5A5A5A'>
                                {t(`BRANCH.TAB.SENTTING.CALCULATE.PAY_${showType}.CREDIT_CARD_DEDUCTION_RATE_TYPE`)}
                            </Typography>
                        </Grid >
                        <Grid item sm={6}>
                            <Typography fontSize={'16px'} fontWeight={'400'} paddingLeft='20px' color='#5A5A5A'>
                                {t(`BRANCH.TAB.SENTTING.CALCULATE.PAY_${showType}.DF_AFTER_CARD_DEDUCTION_CALC`)}
                            </Typography>
                        </Grid >
                    </Grid>
                    <Grid container item>
                        <Grid item sm={6}>
                            <Typography fontSize={'16px'} fontWeight={'400'} paddingLeft='20px' color='#5A5A5A'>
                                {t(`BRANCH.TAB.SENTTING.CALCULATE.PAY_${showType}.NET_DF`)}
                            </Typography>
                        </Grid >
                        <Grid item sm={6}>
                            <Typography fontSize={'16px'} fontWeight={'400'} paddingLeft='20px' color='#5A5A5A'>
                                {t(`BRANCH.TAB.SENTTING.CALCULATE.PAY_${showType}.NET_DF_CALC`)}
                            </Typography>
                        </Grid >
                    </Grid>
                </Box>
            </Box>
        </Box>
    )
}